/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Stack, xcss } from '@atlaskit/primitives';
import { Hide, Show } from '@atlaskit/primitives/responsive';

import { AbsolutePosition, RelativePosition } from '../position';

import BannerLeft from './_images/banner-left';
import BannerRight from './_images/banner-right';
import BannerRightMobile from './_images/banner-right-mobile';

const heroStyles = xcss({
	paddingBlock: 'space.1000',
	paddingInline: 'space.200',
	justifyContent: 'start',
	'@media (min-width: 48rem)': {
		justifyContent: 'center',
		paddingInline: 'space.800',
	},
	minHeight: '440px',
});

const headingContainerStyles = xcss({
	paddingBlock: 'space.1000',
	textAlign: 'left',
	alignItems: 'start',
	'@media (min-width: 48rem)': {
		alignItems: 'center',
		maxWidth: '700px',
		textAlign: 'center',
	},
	zIndex: '1',
});

export const Hero = ({ title, subtitle }: { title: ReactNode; subtitle: ReactNode }) => {
	return (
		<RelativePosition>
			<AbsolutePosition top="0px" left="0px">
				<Show above="lg">
					<RelativePosition>
						<AbsolutePosition left="0px" top="0px">
							<BannerLeft />
						</AbsolutePosition>
					</RelativePosition>
				</Show>
			</AbsolutePosition>
			<Inline xcss={heroStyles} alignInline="center">
				<Stack space="space.300" alignInline="center" xcss={headingContainerStyles}>
					{title}
					{subtitle}
				</Stack>
			</Inline>
			<AbsolutePosition top="0px" right="0px">
				<Show above="md">
					<BannerRight />
				</Show>
				<Hide above="md">
					<BannerRightMobile />
				</Hide>
			</AbsolutePosition>
		</RelativePosition>
	);
};
